module.exports = "/packs/images/svg/ireland/facilities/softplay~4a2f1692ef4d6318b7576cef391ab1c3.svg";